import Component from 'vue-class-component'

import './image-popup.scss'

import { ImageTransferHelper, MediaTransferHelper } from '@skinsoft/media-transfer-helper'
import { ReactiveVue } from '@skinsoft/reactive-vue'
import { IMAGE_UPLOADED_TOPIC, ITEM_CREATION_IMG_POPUP_ADD_MEDIA, MEDIA_END_LOADING_TOPIC } from '@skinsoft/bus/src/busTopics'

export interface AddMediaEvent {
    cacheKey: string,
    newMediaId?: string
}

@Component({
    template: require('./item-creation-image-popup.html'),
})
export class ItemCreationImagePopup extends ReactiveVue {
    public img = null
    private $imageTransferHelper: ImageTransferHelper

    public mounted() {
        this.open()
    }

    public imageChange(image) {
        const file = image.target.files[0]
        const reader = new FileReader()
        reader.readAsDataURL(file)
        reader.addEventListener(
            'load',
            async () => {
                const media = { url: reader.result, file }
                if (media.url == null) {
                    media.url = ''
                } else if (media.url instanceof ArrayBuffer) {
                    media.url = media.url.toString()
                }
                const uploadResult = await this.$imageTransferHelper.uploadImage(
                    file.type,
                    file,
                    media.url,
                    false,
                    !window.navigator.onLine,
                )
                this.$emit('imageChoice', uploadResult.cacheKey)

                if(window.navigator.onLine && uploadResult.fileName) {
                    const fileName = uploadResult.fileName
                    if(fileName) {

                        this.emitOnBus(IMAGE_UPLOADED_TOPIC)

                        try {
                            const newMedia = await MediaTransferHelper.getInstance().repeatFindingMediaIdFromFileName(fileName)
                            this.$imageTransferHelper.addImageToReporterSubAlbum(newMedia.id)
                            this.emitOnBus(
                                ITEM_CREATION_IMG_POPUP_ADD_MEDIA,
                                {cacheKey: uploadResult.cacheKey, newMediaId: newMedia.id}
                            )
                        } catch(err) {
                            console.debug(err)
                        }

                        this.emitOnBus(MEDIA_END_LOADING_TOPIC)
                        return
                    }
                }
            },
            false,
        )
    }

    public open() {
        ;(this.$refs.modal as any).show()
    }

    public loadImage() {
        ;(this.$refs.upload as any).click()
    }

    public close() {
        this.$emit('closePopup')
    }
}
